module.exports = __webpack_public_path__ + "static/img/img-vision.2b49a88.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landing_page/img-vision.png
// module id = rayf
// module chunks = 36